import Scene from './Scene';
import common from '../common';
import {translate, Text} from '../utils';

export default class PreloaderScene extends Scene {
	constructor() {
		super();

		this.loaded = 0;

		this._preloaderFill = null;
		this._preloaderMask = null;
	}

	init() {
		super.init();

		const bg = new PIXI.Sprite(P3.assets.texture('ui_bg_1'));
		bg.anchor.set(0.5);
		bg.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5);
		bg.width = 2000;
		this.addChild(bg);

		for (let i = 0; i < 4; i++) {
			const codetile = new PIXI.Sprite(P3.assets.texture('ui_bg_1_tile'));

			codetile.anchor.set(0, 0.5);
			codetile.position.set(-68 + (i * 450), common.STAGE_HEIGHT * 0.5);
			this.addChild(codetile);
		}

		this._createVerticalLines(12);
		this._createHorizontalLines(4);

		const frameTop = new PIXI.Container();
		frameTop.rotation = 180 * PIXI.DEG_TO_RAD;
		this.addChild(frameTop);

		const frameTop1 = new PIXI.Sprite(P3.assets.texture('ui_frame'));
		frameTop1.anchor.set(0, 0);
		frameTop1.scale.x = -1;
		frameTop.addChild(frameTop1);

		const frameTop2 = new PIXI.Sprite(P3.assets.texture('ui_frame'));
		frameTop2.anchor.set(0, 0);
		frameTop.addChild(frameTop2);

		const frameBottom = new PIXI.Container();
		this.addChild(frameBottom);

		const frameBottom1 = new PIXI.Sprite(P3.assets.texture('ui_frame'));
		frameBottom1.anchor.set(1, 1);
		frameBottom.addChild(frameBottom1);

		const frameBottom2 = new PIXI.Sprite(P3.assets.texture('ui_frame'));
		frameBottom2.anchor.set(1, 1);
		frameBottom2.scale.x = -1;
		frameBottom.addChild(frameBottom2);

		frameBottom.position.set((common.STAGE_WIDTH * 0.5), common.STAGE_HEIGHT);
		frameTop.position.set((common.STAGE_WIDTH * 0.5), frameTop.height);

		const logo = new PIXI.Sprite(P3.assets.texture('ui_ben10_logo'));
		logo.anchor.set(0.5);
		logo.position.set(common.STAGE_WIDTH * 0.5, (common.STAGE_HEIGHT * 0.5) - 150);
		this.addChild(logo);

		const hackathonlogo = new PIXI.mesh.NineSlicePlane(P3.assets.texture('ui_hackaton_logo'), 130, 100, 40, 61);
		this.addChild(hackathonlogo);

		const titleText = Text(translate('GAME.TITLE'), {font: '60px Title', align: 'center'});
		titleText.tint = 0xFFFFFF;
		titleText.anchor.set(0.5);
		hackathonlogo.addChild(titleText);

		hackathonlogo.height = titleText.height + 100;
		hackathonlogo.width = titleText.width + 100;
		titleText.position.set(hackathonlogo.width * 0.5, (hackathonlogo.height * 0.5) - 15);
		hackathonlogo.position.set((common.STAGE_WIDTH * 0.5) - (hackathonlogo.width * 0.5), logo.y + 150);

		const loadingText = Text(translate('GAME.LOADING'), {font: '52px Ahkio Regular', align: 'center'});
		loadingText.tint = 0xFFFFFF;
		loadingText.anchor.set(0.5);
		loadingText.position.set(common.STAGE_WIDTH * 0.5, (common.STAGE_HEIGHT * 0.5) + 180);
		this.addChild(loadingText);

		const preloaderBG = new PIXI.Sprite(P3.assets.texture('ui_loader_bg'));
		preloaderBG.anchor.set(0.5);
		preloaderBG.position.set(common.STAGE_WIDTH * 0.5, (common.STAGE_HEIGHT * 0.5) + 235);
		this.addChild(preloaderBG);

		this._preloaderFill = new PIXI.Sprite(P3.assets.texture('ui_loader_fill'));
		this._preloaderFill.anchor.set(0.5);
		this._preloaderFill.position.set(common.STAGE_WIDTH * 0.5, (common.STAGE_HEIGHT * 0.5) + 235);
		this.addChild(this._preloaderFill);

		this._preloaderMask = new PIXI.Graphics();
		this._preloaderMask.beginFill(0xFF0000);
		this._preloaderMask.drawRect(0, 0, this._preloaderFill.width, this._preloaderFill.height);
		this._preloaderMask.endFill();
		this.addChild(this._preloaderMask);
		this._preloaderMask.position.set(0, this._preloaderFill.y - (this._preloaderFill.height * 0.5));

		this._preloaderFill.mask = this._preloaderMask;
	}

	_createHorizontalLines(count) {
		for (let i = 0; i < count; i++) {
			const line = new PIXI.Sprite(P3.assets.texture('ui_bg_gridline'));

			line.anchor.set(0.5);
			line.alpha = P3.math.random(0.2, 0.7);
			line.rotation = (P3.math.random(-5, 5) * PIXI.DEG_TO_RAD) + (90 * PIXI.DEG_TO_RAD);
			line.height = common.STAGE_WIDTH + 200;
			line.position.set(common.STAGE_WIDTH * 0.5, (common.STAGE_HEIGHT / count) * i);
			this.addChild(line);
		}
	}

	_createVerticalLines(count) {
		for (let i = 0; i < count; i++) {
			const line = new PIXI.Sprite(P3.assets.texture('ui_bg_gridline'));

			line.anchor.set(0.5);
			line.alpha = P3.math.random(0.2, 0.7);
			line.rotation = P3.math.random(-10, 10) * PIXI.DEG_TO_RAD;
			line.height = common.STAGE_HEIGHT;
			line.position.set((common.STAGE_WIDTH / count) * i, common.STAGE_HEIGHT * 0.5);
			this.addChild(line);
		}
	}

	destroy() {
		super.destroy();
	}

	update() {
		this._preloaderMask.x = (this._preloaderFill.width * this.loaded) + this._preloaderFill.width + 27;
	}
}
